import Weapons from "../enums/WeaponType";
import Game from "./Game";
import GameCore from "./GameCore";
import { Character } from "./character/Character";

export default class Player extends Phaser.Physics.Arcade.Sprite {
  startingWeapon: Weapons;
  lastFaceDirection: Phaser.Math.Vector2;
  moveSpeed: number;
  area: number;
  amount: number;
  power: number;
  speed: number;
  duration: number;
  cooldown: number;
  hp: number;
  isDead: boolean;
  xp: number;
  level: number;
  maxHp: number;
  growth: number;
  luck: number;
  shields: number;
  armor: number;
  maxHistory: number;
  historyIndex: number;
  HasWalkingAnimation: boolean;
  invulTime: number;
  private _invul: boolean;
  WorldBoxCollider: Phaser.Geom.Rectangle;
  //evilValue: number //not used, can be removed
  private characterData: Character;
  receivingDamage: boolean;
  posHistory: Phaser.Math.Vector2[];

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    characterData: Character
  ) {
    const visuals = characterData.getCharacterVisuals();
    const CharScale = 2.5;
    super(scene, x, y, visuals.spriteName);

    this.characterData = characterData;

    // Get upgraded stats
    const upgradedStats = characterData.getAllStatsWithUpgrades();

    // Initialize from upgraded character stats
    this.maxHp = upgradedStats.maxHp;
    // this.hp = this.maxHp // Set initial HP to max
    this.moveSpeed = upgradedStats.moveSpeed;
    this.power = upgradedStats.power;
    this.area = upgradedStats.area;
    this.speed = upgradedStats.speed;
    this.duration = upgradedStats.duration;
    this.cooldown = upgradedStats.cooldown;
    this.luck = upgradedStats.luck;
    this.growth = upgradedStats.growth;
    this.armor = upgradedStats.armor;
    this.shields = upgradedStats.shield;
    this.amount = upgradedStats.amount;

    // Initialize other properties with defaults
    this.hp = localStorage.getItem("dieFast") ? 1 : 100;
    this.isDead = false;
    this.xp = 0;
    this.level = 1;
    this.lastFaceDirection = new Phaser.Math.Vector2(1, 0);
    this.startingWeapon = characterData.startingWeapon;

    // Initialize physics and position tracking
    this.posHistory = new Array();
    this.maxHistory = 3;
    this.historyIndex = 0;

    // Initialize invulnerability states
    this.invulTime = 0;
    this._invul = false;
    this.receivingDamage = false;

    // Set visual properties
    this.setScale(GameCore.PixelScale * CharScale);
    this.HasWalkingAnimation = !!visuals.animationKey;

    // Setup physics and sprite
    this.scene.add.existing(this);
    this.scene.physics.add.existing(this);
    //this.setOrigin(0.5, 0.5) //obsolete, because it's a default origin

    //collision management for new sprite sheet format
    const originalCollisionW = 10;
    const originalCollisionH = 20;

    this.Body.setSize(originalCollisionW, originalCollisionH); //caution, Phaser automatically multuiply those consts to scaling factor from setScale
    this.Body.setOffset(this.Body.offset.x, this.Body.offset.y - 4);

    // Initialize position history
    for (let i = 0; i <= this.maxHistory; i++) {
      this.posHistory.push(new Phaser.Math.Vector2(this.x, this.y));
    }

    // Setup world collider
    this.WorldBoxCollider = new Phaser.Geom.Rectangle(
      0,
      0,
      this.scene.renderer.width,
      this.scene.renderer.height
    );

    // Set initial sprite frame
    if (visuals.spriteName) {
      this.setFrame(0);
    }
  }

  //uncomment this to display borders for debugging

  //if (process.env.NODE_ENV === 'development') {
  //const debugGraphics = this.scene.add.graphics().setDepth(1000);
  //this.scene.events.on('update', () => {
  //    debugGraphics.clear();
  //    //display physics body borders
  //    debugGraphics.lineStyle(2, 0xff0000);
  //    debugGraphics.strokeRect(
  //        this.Body.x,
  //        this.Body.y,
  //        this.Body.width,
  //        this.Body.height
  //    );
  //    console.log(this.Body.width, this.Body.height)
  //    //display sprite frame borders
  //    debugGraphics.lineStyle(2, 0x00ff00);
  //    debugGraphics.strokeRect(
  //      this.x - this.displayWidth*this.originX,
  //      this.y - this.displayHeight*this.originY,
  //      this.displayWidth,
  //      this.displayHeight
  //    );
  //});
  //}

  public get IsInvul(): boolean {
    return this._invul;
  }

  public set IsInvul(value: boolean) {
    if (this._invul !== value) {
      this._invul = value;
      if (this._invul) {
        this.setTintFill(0xffffbb);
      } else {
        this.clearTint();
      }
    }
  }

  RecoverHp(hp: number) {
    if (this.isDead) return;
    this.hp += hp;
    if (this.hp > this.maxHp) {
      this.hp = this.maxHp;
    }
    Game.Core.PlayerUI.Update();
  }

  LevelUp() {
    this.level++;
    Game.Core.PlayerUI.Update();
    Game.Core.PlayerUI.UpdatePlayerLevel();
  }

  MakeLevelOne() {
    this.level = 1;
    this.hp = this.maxHp;
    Game.Core.PlayerUI.Update();
  }

  GetDamaged(PPower: number = 1) {
    if (!this.receivingDamage && !(this.IsInvul || this.hp <= 0)) {
      if (this.shields > 0) {
        this.shields -= 1;
        this.OnGetDamaged(0xffffbb, 240);
        return Game.Core.scene.events.emit("Player_LostShield");
      }
      if (this.armor > 0) {
        PPower -= this.armor;
        PPower = PPower < 1 ? 1 : PPower;
      }
      this.hp -= PPower;
      if (this.hp <= 0) {
        this.hp = 0;
        this.Die();
        Game.Core.GameOver();
      } else {
        this.OnGetDamaged();
      }
      Game.Core.PlayerUI.Update();
    }
  }
  Die() {
    // throw new Error('Method not implemented.')
  }

  Revive() {
    this.isDead = false;
    this.Body.enable = true;
    this.setScale(GameCore.PixelScale);
    this.RecoverHp(this.maxHp);
    this.SetInvulForMilliSeconds(2000);
    Game.Core.PlayerUI.Update();
  }
  SetInvulForMilliSeconds(time: number) {
    this.IsInvul = true;
    this.invulTime += time;
  }

  OnGetDamaged(fill = 16711680, delay = 120) {
    if (!this.receivingDamage) {
      this.setTintFill(fill);
      Game.Core.scene.time.addEvent({
        delay: delay,
        loop: false,
        callback: () => {
          this.restoreTint();
        },
      });
      this.receivingDamage = true;
    }
  }
  restoreTint() {
    this.setTint(0xffffff);
    this.receivingDamage = false;
  }

  Update(delta: number = 0) {
    if (!this.isDead) {
      this.invulTime -= delta;
      if (this.invulTime <= 0) {
        this.invulTime = 0;
      }
      this.IsInvul = this.invulTime > 0;
      this.setDepth(0);
      if (this.body) {
        if (this.body.velocity.x < 0) {
          this.setFlipX(true);
        }
        if (this.body.velocity.x > 0) {
          this.setFlipX(false);
        }

        // Check if player is moving
        const isMoving =
          this.body.velocity.x !== 0 || this.body.velocity.y !== 0;

        if (isMoving) {
          const visuals = this.characterData.getCharacterVisuals();
          // Play running animation if available
          if (
            this.HasWalkingAnimation &&
            !this.anims.isPlaying &&
            visuals.animationKey
          ) {
            this.play(visuals.animationKey);
          }
        } else {
          // Stop animations when not moving
          if (this.anims.isPlaying) {
            this.anims.stop();
          }

          this.setFrame(1);
        }
      }

      this.historyIndex < this.maxHistory
        ? this.historyIndex++
        : (this.historyIndex = 0);
      if (this.body) {
        this.posHistory[this.historyIndex].copy(this.body.position);
      }
      this.WorldBoxCollider.x = this.x - 0.5 * this.scene.renderer.width;
      this.WorldBoxCollider.y = this.y - 0.5 * this.scene.renderer.height;
    }
  }

  public get Body(): Phaser.Physics.Arcade.Body {
    return this.body as Phaser.Physics.Arcade.Body;
  }
}
